/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Data_ProcessingInputs */

const en_footer_data_processing = /** @type {(inputs: Footer_Data_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Processing`)
};

const zh_hans1_footer_data_processing = /** @type {(inputs: Footer_Data_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数据处理协议`)
};

const pt_br2_footer_data_processing = /** @type {(inputs: Footer_Data_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processamento de Dados`)
};

const es_footer_data_processing = /** @type {(inputs: Footer_Data_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesamiento de datos`)
};

const fr_footer_data_processing = /** @type {(inputs: Footer_Data_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traitement des données`)
};

const de_footer_data_processing = /** @type {(inputs: Footer_Data_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auftragsverarbeitung`)
};

const ru_footer_data_processing = /** @type {(inputs: Footer_Data_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обработка данных`)
};

const it_footer_data_processing = /** @type {(inputs: Footer_Data_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trattamento dei dati`)
};

/**
* | output |
* | --- |
* | "Data Processing" |
*
* @param {Footer_Data_ProcessingInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const footer_data_processing = /** @type {((inputs?: Footer_Data_ProcessingInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Data_ProcessingInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_footer_data_processing(inputs)
	if (locale === "pt-BR") return pt_br2_footer_data_processing(inputs)
	if (locale === "es") return es_footer_data_processing(inputs)
	if (locale === "fr") return fr_footer_data_processing(inputs)
	if (locale === "de") return de_footer_data_processing(inputs)
	if (locale === "ru") return ru_footer_data_processing(inputs)
	if (locale === "it") return it_footer_data_processing(inputs)
	return en_footer_data_processing(inputs)
});